import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, NgIf, DatePipe, DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { DataService } from '../../../../shared/data.service';
import { Utils } from '../../../../shared/utils';

@Component({
  selector: 'app-tv-facts',
  standalone: true,
  imports: [CommonModule, NgIf, DatePipe, DecimalPipe],
  templateUrl: './tv-facts.html',
  styleUrl: './tv-facts.scss'
})
export class TvFacts implements OnInit, OnDestroy {

  tvDetails: any = null;
  private subscription!: Subscription;
  frontendUrl = environment.frontendUrl;
  backendUrl = environment.backendUrl;

  constructor(private dataService: DataService, private utils: Utils) {}

  ngOnInit(): void {
    this.subscription = this.dataService.message$.subscribe(
      data => {
        if (data) {
          this.tvDetails = data;
        }
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getStatusClass(status: string): string {
    if (!status) return 'status-default';
    const s = status.toLowerCase();
    if (s.includes('returning') || s.includes('in production')) return 'status-active';
    if (s.includes('ended') || s.includes('concluded')) return 'status-ended';
    if (s.includes('canceled') || s.includes('cancelled')) return 'status-canceled';
    return 'status-default';
  }

  getLanguageName(code: string): string {
    if (!code) return '';
    try {
      const displayNames = new Intl.DisplayNames(['en'], { type: 'language' });
      return displayNames.of(code) || code.toUpperCase();
    } catch {
      return code.toUpperCase();
    }
  }

  onImageError(event: Event) {
    return this.utils.onImageVerticalError(event);
  }
}
